'use client';
import { css } from 'styled-components';
export const verticalRhythm = (baseSpacing) => css `
  > * {
    margin-bottom: ${o => baseSpacing ?? o.theme.spacing(4)};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
//# sourceMappingURL=styles.js.map